/* CHANGE LOG BY DEVESH 2026-10-21: extra card frames (data-frames) now build on first touch / hover / swipe instead of when the card nears the viewport. */
/* CHANGE LOG BY DEVESH 2026-09-16: the Discover panel's money-back break is the coded banner, not an image. */
/* CHANGE LOG BY DEVESH 2026-09-16: rail sort reads the active option in the re-rendered markup (URL could lag the swap). */
/* CHANGE LOG BY DEVESH 2026-09-16: filters + sort also apply to Our Most Loved (client-side: checked facet labels → colour keyword / size match; sort_by price/created). */
/* CHANGE LOG BY DEVESH 2026-09-16: desktop hover arrows on card frames (mouseover injects .p-nav; click steps one frame, wraps). */
/* CHANGE LOG BY DEVESH 2026-09-16: sort menu placed under the chip with fixed coordinates (toolbar overflow clipped it); closes on scroll. */
/* CHANGE LOG BY DEVESH 2026-09-16: panes mounted from <template> are importNode'd and their first-frame images lose loading=lazy — iOS Safari left lazy images adopted from template content blank. */
/* Delegated + idempotent: the theme's facets-form swaps this whole section's HTML on every
     filter change, so nothing here may depend on a node surviving. */
  if (!window.__ncp3Bound) {
    window.__ncp3Bound = true;
    var ncp3Root = function (el) { return el.closest('[data-ncp3]'); };
    var ncp3Esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var ncp3Lock = function (on) { document.documentElement.style.overflow = on ? 'hidden' : ''; };

    /* Re-render this section from a URL without a page load — the same 'facet:update' the theme's
       own facets form and sort popover dispatch; the theme fetches ?section_id= and swaps the HTML. */
    function ncp3Go(root, url) {
      url.searchParams.set('section_id', root.getAttribute('data-section-id'));
      document.documentElement.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url: url } }));
    }

    /* ── filter sheet ── */
    function ncp3Sheet(root, open) {
      var sh = root.querySelector('[data-ncp3-sheet]'), sc = root.querySelector('[data-ncp3-scrim]');
      if (!sh) return;
      sh.hidden = !open; if (sc) sc.hidden = !open;
    }
    document.addEventListener('change', function (e) {
      var row = e.target.closest('.ncp3-row'); if (!row) return;
      var form = row.closest('form');
      if (e.target.type === 'radio') form.querySelectorAll('input[name="' + e.target.name + '"]').forEach(function (i) { i.closest('.ncp3-row').classList.toggle('on', i.checked); });
      else row.classList.toggle('on', e.target.checked);
    });

    /* ── Discover panel ── */
    var ncp3DiscData = null;
    function ncp3DiscBreak(i) {
      /* built in markup, same as the in-grid banner — no image request, sharp at any width */
      if (i % 2 === 0) {
        /* 7-day: the new artwork on desktop, the built-in markup on phones — the new file is a
           5968x800 desktop crop and far too heavy to send to a phone */
        return '<div class="ncp3-disc-break">'
          + '<img class="sbn-d" width="5968" height="800" src="https://cdn.shopify.com/s/files/1/0450/3476/6485/files/7_DAY_DESKTOP_V2.jpg?v=1789558559&width=2000" alt="7 day money back guarantee" loading="lazy" decoding="async">'
          + '<div class="ncp3-mbn sbn-m">'
          + '<p class="ncp3-mbn-t">7 - Day <b>Money Back Guarantee</b></p>'
          + '<p class="ncp3-mbn-s">Love it or get your money back</p></div></div>';
      }
      /* the data strip: happy customers / pincodes reached / products delivered */
      return '<div class="ncp3-disc-break">'
        + '<img class="sbn-m" width="1584" height="268" src="https://cdn.shopify.com/s/files/1/0450/3476/6485/files/DATA_BANNER_MOBILE.webp?v=1789633299&width=1000" alt="8 lakh+ happy customers, 20,000+ pincodes reached, 15 lakh+ products delivered" loading="lazy" decoding="async">'
        + '<img class="sbn-d" width="2940" height="268" src="https://cdn.shopify.com/s/files/1/0450/3476/6485/files/8l.webp?v=1790831219&width=2000" alt="" loading="lazy" decoding="async"></div>';
    }
    function ncp3Slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function ncp3DiscRender(panel) {
      var body = panel.querySelector('[data-ncp3-disc-body]'), tabs = panel.querySelector('[data-ncp3-disc-tabs]');
      var groups = (ncp3DiscData && ncp3DiscData[panel.getAttribute('data-gender')]) || [];
      var exclude = (panel.getAttribute('data-exclude') || '').split('|').filter(Boolean);
      var out = [], names = [];
      groups.forEach(function (g) {
        var cards = g.cards.filter(function (c) { return exclude.indexOf(c.type) === -1; });
        if (!cards.length) return;
        if (names.length) out.push(ncp3DiscBreak(names.length - 1));
        names.push(g.group);
        out.push('<div data-ncp3-disc-sec="' + ncp3Slug(g.group) + '"><div class="ncp3-disc-sechead">' + ncp3Esc(g.group) + '</div><div class="ncp3-disc-grid">'
          + cards.map(function (c) { return '<a class="ncp3-disc-card" href="/products/' + encodeURIComponent(c.handle) + '"><span class="ncp3-disc-media"><img src="' + ncp3Esc(c.image) + '" alt="' + ncp3Esc(c.label) + '" loading="lazy"></span><span class="ncp3-disc-name">' + ncp3Esc(c.label) + '</span></a>'; }).join('')
          + '</div></div>');
      });
      body.innerHTML = out.join('') || '<div class="ncp3-disc-loading">Nothing to show.</div>';
      if (tabs && names.length) {
        tabs.innerHTML = '<button type="button" class="ncp3-disc-tab on" data-ncp3-disc-tab="all">All</button>' + names.map(function (n) { return '<button type="button" class="ncp3-disc-tab" data-ncp3-disc-tab="' + ncp3Slug(n) + '">' + ncp3Esc(n) + '</button>'; }).join('');
        tabs.hidden = false;
      }
    }
    function ncp3DiscOpen(panel) {
      panel.hidden = false; ncp3Lock(true);
      if (panel.getAttribute('data-built')) return;
      panel.setAttribute('data-built', '1');
      var draw = function () { ncp3DiscRender(panel); };
      if (ncp3DiscData) return draw();
      fetch(panel.getAttribute('data-src')).then(function (r) { return r.json(); }).then(function (j) { ncp3DiscData = j; draw(); })
        .catch(function () { panel.querySelector('[data-ncp3-disc-body]').innerHTML = '<div class="ncp3-disc-loading">Could not load categories.</div>'; panel.removeAttribute('data-built'); });
    }
    document.addEventListener('scroll', function (e) {
      var panel = e.target && e.target.getAttribute && e.target.hasAttribute('data-ncp3-disc') ? e.target : null;
      if (!panel || panel.__lock > Date.now()) return;
      var top = panel.querySelector('.ncp3-disc-top').offsetHeight, y = panel.scrollTop + top + 60, cur = 'all';
      var secs = panel.querySelectorAll('[data-ncp3-disc-sec]');
      secs.forEach(function (s) { if (s.offsetTop <= y) cur = s.getAttribute('data-ncp3-disc-sec'); });
      if (panel.scrollTop < 30) cur = 'all';
      /* A short last group never passes the header line, so at the very bottom it is the answer. */
      if (secs.length && panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 4) cur = secs[secs.length - 1].getAttribute('data-ncp3-disc-sec');
      panel.querySelectorAll('.ncp3-disc-tab').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-ncp3-disc-tab') === cur); });
    }, true);

    /* ── frame progress bar: fills with the scroll position of its card's frames ── */
    document.addEventListener('scroll', function (e) {
      var car = e.target && e.target.classList && e.target.classList.contains('p-car') ? e.target : null;
      if (!car) return;
      var bar = car.parentElement.querySelector('.p-bar > span'); if (!bar) return;
      var max = car.scrollWidth - car.clientWidth; if (max <= 0) return;
      // Filled from the left: one frame's share at rest, the full width on the last frame.
      var one = car.clientWidth / car.scrollWidth * 100;
      bar.style.width = (one + (100 - one) * (car.scrollLeft / max)) + '%';
    }, true);

    /* the sort menu is fixed to the viewport (the toolbar scrolls sideways and would clip it) — close it on scroll */
    window.addEventListener('scroll', function () { document.querySelectorAll('[data-ncp3-sortmenu]:not([hidden])').forEach(function (x) { x.hidden = true; }); }, { passive: true });

    /* ── desktop hover arrows: added to a card on first hover (frames built first), step one frame per click ── */
    var ncp3Arrow = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="' + (d < 0 ? '15 5 8 12 15 19' : '9 5 16 12 9 19') + '"/></svg>'; };
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest && e.target.closest('[data-ncp3] .p-card'); if (!card || card.querySelector('.p-nav')) return;
      var car = card.querySelector('.p-car'), box = card.querySelector('.p-img-box'); if (!car || !box) return;
      ncp3Build(car);
      var nav = document.createElement('span'); nav.className = 'p-nav';
      nav.innerHTML = '<button type="button" data-ncp3-step="-1" aria-label="Previous image">' + ncp3Arrow(-1) + '</button><button type="button" data-ncp3-step="1" aria-label="Next image">' + ncp3Arrow(1) + '</button>';
      box.appendChild(nav);
      if (car.scrollWidth > car.clientWidth + 2) nav.classList.add('is-on');
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ncp3-step]'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var car = b.closest('.p-card').querySelector('.p-car'), w = car.clientWidth, d = Number(b.getAttribute('data-ncp3-step'));
      var max = car.scrollWidth - w, next = car.scrollLeft + d * w;
      if (next < -1) next = max; else if (next > max + 1) next = 0;   /* wrap at the ends */
      car.scrollTo({ left: next, behavior: 'auto' });   /* instant: smooth scroll fights the mandatory snap and lands back at 0 */
    }, true);

    /* ── filters + sort for Our Most Loved: the storefront facets only reach the main grid, so the rail is
       filtered client-side from the checked facet labels and sort_by. Colour groups are Search & Discovery
       gids, so the match is by label keyword against the card's colour name.
       ponytail: keyword table, not the real group membership; extend NCP3_HUES when a label misses. ── */
    var NCP3_HUES = { black: ['black', 'charcoal', 'jet'], blue: ['blue', 'navy', 'indigo', 'denim', 'sky', 'cobalt', 'teal'], brown: ['brown', 'tan', 'khaki', 'khakhi', 'coffee', 'mocha', 'taupe', 'fawn', 'rust', 'camel', 'chocolate', 'walnut'],
      grey: ['grey', 'gray', 'ash', 'slate', 'steel', 'stone'], green: ['green', 'olive', 'sage', 'mint', 'forest', 'moss', 'emerald', 'pista'], maroon: ['maroon', 'wine', 'burgundy', 'plum', 'cherry'],
      pink: ['pink', 'rose', 'blush', 'peach', 'coral', 'salmon', 'mauve', 'onion'], white: ['white', 'ivory', 'off-white', 'offwhite', 'off white'], ecru: ['ecru', 'cream', 'beige', 'oat', 'natural', 'sand', 'vanilla'],
      lilac: ['lilac', 'lavender', 'purple', 'violet'], red: ['red', 'scarlet', 'crimson'], yellow: ['yellow', 'mustard', 'lemon', 'lomen', 'ochre'], orange: ['orange', 'tangerine', 'brick'] };
    function ncp3HueOf(name) {
      var n = String(name || '').toLowerCase(), hit = '';
      Object.keys(NCP3_HUES).forEach(function (k) { if (!hit && NCP3_HUES[k].some(function (w) { return n.indexOf(w) !== -1; })) hit = k; });
      return hit || 'others';
    }
    function ncp3Active(root) {
      var colours = [], sizes = [];
      root.querySelectorAll('[data-ncp3] input[type="checkbox"]:checked').forEach(function (i) {
        var row = i.closest('label'), label = row ? row.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
        if (i.name === 'filter.v.option.size') sizes.push((i.value || label).toLowerCase());
        else if (i.name === 'filter.p.m.custom.product_variant_name') colours.push(label);
      });
      /* sort from the re-rendered markup (the active option), not the URL — the facets swap can land before the URL updates */
      var on = root.querySelector('[data-ncp3] [data-ncp3-sort-opt].on');
      return { colours: colours, sizes: sizes, sort: on ? on.getAttribute('data-ncp3-sort-opt') : (new URL(location.href).searchParams.get('sort_by') || '') };
    }
    function ncp3RailApply(root) {
      var f = ncp3Active(root);
      root.querySelectorAll('[data-ncp3-ml-pane]').forEach(function (pane) {
        var grid = pane.querySelector('.ncp3-grid'); if (!grid) return;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.p-card')), shown = 0;
        cards.forEach(function (c, i) {
          if (c.dataset.idx == null) c.dataset.idx = i;
          var ok = true;
          if (f.colours.length) { var hue = ncp3HueOf(c.getAttribute('data-colour')); ok = f.colours.some(function (l) { return l === hue || (l === 'others' && hue === 'others') || hue.indexOf(l) === 0; }); }
          if (ok && f.sizes.length) { var have = (c.getAttribute('data-sizes') || '').toLowerCase(); ok = f.sizes.some(function (z) { return have.indexOf('|' + z + '|') !== -1; }); }
          if (c.hidden === ok) c.hidden = !ok;   /* touch the DOM only on change: the section observer re-runs this on every mutation */
          if (ok) shown++;
        });
        var key = { 'price-ascending': 1, 'price-descending': -1 }[f.sort] || 0, byDate = f.sort === 'created-descending' || f.sort === 'created-ascending';
        cards.sort(function (a, b) {
          if (key) return key * (Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price')));
          if (byDate) return (f.sort === 'created-descending' ? -1 : 1) * (Number(a.getAttribute('data-created')) - Number(b.getAttribute('data-created')));
          return Number(a.dataset.idx) - Number(b.dataset.idx);
        });
        var cur = Array.prototype.slice.call(grid.querySelectorAll('.p-card'));
        if (cards.some(function (c, i) { return c !== cur[i]; })) cards.forEach(function (c) { grid.appendChild(c); });
        var note = grid.querySelector('.ncp3-ml-empty');
        if (!shown && !note) { note = document.createElement('p'); note.className = 'ncp3-ml-empty'; note.textContent = 'No pieces here match the current filters.'; grid.appendChild(note); }
        else if (shown && note) note.remove();
      });
    }
    ncp3RailApply(document);
    window.addEventListener('popstate', function () { setTimeout(function () { ncp3RailApply(document); }, 50); });

    /* ── card frames: frame 1 is markup, the rest come from data-frames ([href, src, w, h, alt]) and are
       built once the card is within 300px of the viewport. Hidden panes never build until shown. ── */
    function ncp3Build(car) {
      var list = car.getAttribute('data-frames'); if (!list) return;
      car.removeAttribute('data-frames');
      var out = '';
      try { JSON.parse(list).forEach(function (fr) {
        var src = fr[1], img = '<img src="' + src + '" srcset="' + src.replace('width=440', 'width=280') + ' 280w, ' + src + ' 440w, ' + src.replace('width=440', 'width=660') + ' 660w" sizes="(max-width: 768px) 50vw, (max-width: 1023px) 33vw, 20vw" width="' + fr[2] + '" height="' + fr[3] + '" alt="' + ncp3Esc(fr[4]) + '" loading="lazy" decoding="async">';
        out += fr[0] ? '<a class="p-frame" href="' + ncp3Esc(fr[0]) + '" aria-label="' + ncp3Esc(fr[4]) + '">' + img + '</a>' : img;
      }); } catch (err) {}
      car.insertAdjacentHTML('beforeend', out);
    }
    var ncp3FrIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (x) { if (x.isIntersecting) { ncp3FrIO.unobserve(x.target); ncp3Build(x.target); } });
    }, { rootMargin: '300px 0px' }) : null;
    function ncp3Frames(root) {
      root.querySelectorAll('.p-car[data-frames]').forEach(function (car) {   /* 2026-10-21: build the extra frames on the card's first touch / hover / swipe, not when it scrolls near (Slow 4G: they were downloading before the main image) */
        if (car._ncp3W) return; car._ncp3W = 1;
        var go = function () { ncp3Build(car); };
        car.addEventListener('touchstart', go, { passive: true }); car.addEventListener('mouseenter', go); car.addEventListener('scroll', go, { passive: true });
      });
    }
    ncp3Frames(document);
    /* keep the money-back band on a row boundary at every width */
    function ncp3BandAll() { document.querySelectorAll('[data-ncp3]').forEach(ncp3BandRow); }
    ncp3BandAll();
    window.addEventListener('resize', function () { clearTimeout(window.__ncp3Band); window.__ncp3Band = setTimeout(ncp3BandAll, 150); });

    /* ── landing hint: the first card's frames slide left and settle back when the card comes into
       view. A CSS move on the frames, not a scroll — the snap points swallow a programmatic scroll. ── */
    function ncp3Nudge() {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var car = document.querySelector('[data-ncp3-grid] .p-car'); if (!car) return;
      ncp3Build(car); if (car.scrollWidth <= car.clientWidth) return;
      var fire = function () {
        if (car.scrollLeft > 4) return;
        car.classList.add('is-nudge');
        car.addEventListener('animationend', function () { car.classList.remove('is-nudge'); }, { once: true });
      };
      if (!('IntersectionObserver' in window)) return setTimeout(fire, 700);
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (x) { return x.isIntersecting; })) return;
        io.disconnect(); setTimeout(fire, 450);
      }, { threshold: 0.6 });
      io.observe(car);
    }
    if (document.readyState === 'complete') ncp3Nudge(); else window.addEventListener('load', ncp3Nudge, { once: true });

    /* ── Our Most Loved tabs: built from the panes Liquid rendered, so the list never fetches ── */
    function ncp3MlTabs(root) {
      root.querySelectorAll('[data-ncp3-ml]').forEach(function (ml) {
        var bar = ml.querySelector('[data-ncp3-ml-tabs]'); if (!bar || bar.children.length) return;
        var panes = ml.querySelectorAll('[data-ncp3-ml-pane]');
        bar.innerHTML = Array.prototype.map.call(panes, function (p, i) {
          return '<button type="button" role="tab" class="ncp3-ml-tab' + (i === 0 ? ' on' : '') + '" data-ncp3-ml-tab="' + p.getAttribute('data-ncp3-ml-pane') + '" aria-selected="' + (i === 0) + '">' + ncp3Esc(p.getAttribute('data-label')) + '</button>';
        }).join('');
      });
    }
    function ncp3BarH() { document.querySelectorAll('[data-ncp3]').forEach(function (r) { var bar = r.querySelector('.ncp3-bar'); if (bar) r.style.setProperty('--ncp3-bar-h', bar.offsetHeight + 'px'); }); }
    ncp3MlTabs(document); ncp3BarH();
    window.addEventListener('resize', ncp3BarH);
    /* The facets form swaps this section's HTML on a filter change; watch the section's parent only. */
    document.querySelectorAll('[data-ncp3]').forEach(function (r) {
      var host = r.parentElement || document.body;
      new MutationObserver(function () { ncp3MlTabs(document); ncp3BarH(); ncp3Frames(document); ncp3RailApply(document); }).observe(host, { childList: true, subtree: true });
    });

    /* ── back from a product: remember the card that was tapped and bring it back into view.
       Anchoring on the card, not on a pixel offset, survives whatever the browser does with the
       scroll position on the way back; the pixel offset is kept only as a fallback. ── */
    var ncp3Key = 'ncp3:' + location.pathname + location.search;
    var ncp3ScrollT = 0;
    window.addEventListener('scroll', function () {
      if (ncp3ScrollT) return;
      ncp3ScrollT = setTimeout(function () { ncp3ScrollT = 0; try { sessionStorage.setItem(ncp3Key + ':y', String(window.scrollY | 0)); } catch (err) {} }, 150);
    }, { passive: true });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ncp3] .p-card a[href*="/products/"]'); if (!a) return;
      var card = a.closest('.p-card'), idx = Array.prototype.indexOf.call(document.querySelectorAll('[data-ncp3] .p-card'), card);
      try { sessionStorage.setItem(ncp3Key + ':card', JSON.stringify({ i: idx, h: a.getAttribute('href'), t: Math.round(card.getBoundingClientRect().top) })); sessionStorage.setItem(ncp3Key + ':y', String(window.scrollY | 0)); } catch (err) {}
    }, true);
    function ncp3Restore() {
      var saved = null, y = 0;
      try { saved = JSON.parse(sessionStorage.getItem(ncp3Key + ':card') || 'null'); y = Number(sessionStorage.getItem(ncp3Key + ':y') || 0); sessionStorage.removeItem(ncp3Key + ':card'); } catch (err) {}
      if (window.scrollY > 120) return;   /* the browser already put us back */
      var cards = document.querySelectorAll('[data-ncp3] .p-card'), card = null;
      if (saved) {
        card = cards[saved.i] || null;
        if (!card || !card.querySelector('a[href="' + saved.h + '"]')) { var link = document.querySelector('[data-ncp3] .p-card a[href="' + saved.h + '"]'); card = link ? link.closest('.p-card') : card; }
      }
      var tries = 0;
      (function go() {
        if (card) window.scrollBy(0, card.getBoundingClientRect().top - saved.t);   /* put the card back exactly where it sat on screen */
        else if (y > 80) window.scrollTo(0, y);
        else return;
        if (++tries < 8) setTimeout(go, tries < 3 ? 50 : 200);
      })();
    }
    window.addEventListener('pageshow', ncp3Restore);
    if (document.readyState === 'complete') ncp3Restore(); else window.addEventListener('load', ncp3Restore, { once: true });


    var ncp3RvCache = {};
    function ncp3RvFetch(store, pid, page) {
      var key = pid + ':' + page;
      if (ncp3RvCache[key]) return ncp3RvCache[key];
      var url = 'https://storefront-api.loox.io/storefront/v1/store/' + store + '/product-reviews?product_id=' + pid + '&page=' + page + '&limit=' + (page === 1 ? 6 : 10);
      ncp3RvCache[key] = fetch(url).then(function (r) { return r.ok ? r.json() : null; });
      return ncp3RvCache[key];
    }
    function ncp3RvThumb(url, w) {
      var path = String(url).replace(/^https?:\/\/images\.loox\.io/, '');
      return 'https://images.loox.io/cdn-cgi/image/width=' + w + ',quality=72,format=auto' + path;
    }
    /* hover / first touch pulls the reviews AND starts every photo on the first page downloading, so by
       the time the panel opens the images are in the HTTP cache and paint with the text */
    function ncp3RvPrefetch(root, pill) {
      var store = root.getAttribute('data-loox-store'), pid = pill.getAttribute('data-pid');
      if (!store || !pid) return;
      var narrow = window.matchMedia('(max-width: 768px)').matches;
      ncp3RvFetch(store, String(pid).replace(/\D/g, ''), 1).then(function (d) {
        ((d && d.reviews) || []).forEach(function (rv) {
          var m = (rv.media || [])[0];
          if (m && m.url) { var im = new Image(); im.decoding = 'async'; im.src = ncp3RvThumb(m.url, narrow ? 360 : 480); }
        });
      }).catch(function () {});
    }
    /* NO page-load warming: 8 products x 6 photos competed with the product grid's own images on a
       phone and left the tiles blank. Reviews and their photos are fetched on hover / first touch only. */
    function ncp3RvStars(n) {
      var out = '';
      for (var i = 1; i <= 5; i++) out += '<svg class="' + (i <= n ? 'on' : '') + '" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg>';
      return '<span class="ncp3-rv-stars">' + out + '</span>';
    }
    function ncp3RvLoad(root, store, pid, list, page) {
      var box = root.querySelector('[data-ncp3-rv]');
      var more = list.querySelector('[data-ncp3-rv-more]'); if (more) more.remove();
      ncp3RvFetch(store, pid, page).then(function (d) {
        if (box && box.hidden) return;
        var rows = (d && d.reviews) || [];
        if (!rows.length && page === 1) {
          list.innerHTML = '<p class="ncp3-rv-empty">No reviews for this colour yet.</p>';
          box.classList.add('is-ready'); return;
        }
        if (page === 1) {
          list.innerHTML = '';
          var total = (d.pagination || {}).total || rows.length;
          var head = document.createElement('div');
          head.className = 'ncp3-rv-bar';
          head.innerHTML = ncp3RvStars(5) + '<span class="ncp3-rv-total">' + total.toLocaleString('en-IN') + ' Reviews</span>';
          list.appendChild(head);
          var grid = document.createElement('div');
          grid.className = 'ncp3-rv-grid'; grid.setAttribute('data-ncp3-rv-grid', '1');
          list.appendChild(grid);
        }
        var grid = list.querySelector('[data-ncp3-rv-grid]') || list;
        rows.forEach(function (rv) {
          var el = document.createElement('article');
          el.className = 'ncp3-rv-item';
          var when = rv.date ? new Date(rv.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
          var media = (rv.media || []).filter(function (m) { return m.url; }).slice(0, 1).map(function (m) {
            /* Loox photos are ~1 MB camera files and the app offers no resize parameters, but the images
               host runs behind Cloudflare, whose image resizer does: 480w webp lands at ~45 KB, and the
               360w used on phones at less still. Aspect is untouched, so the tile keeps the photo's shape. */
            var narrow = window.matchMedia('(max-width: 768px)').matches;
            /* the same url the prefetch warmed — one size, so the browser reuses that exact response
               instead of picking a different srcset candidate and downloading again */
            return '<img src="' + ncp3Esc(ncp3RvThumb(m.url, narrow ? 360 : 480)) + '"'
              + ' alt="" decoding="async" onload="this.classList.add(\'is-on\')">';
          }).join('');
          el.innerHTML = (media ? '<div class="ncp3-rv-media">' + media + '</div>' : '')
            + '<div class="ncp3-rv-txt">'
            + '<span class="ncp3-rv-who">' + ncp3Esc((rv.reviewer && rv.reviewer.name) || 'Verified buyer') + '</span>'
            + ncp3RvStars(rv.rating || 0)
            + (rv.body ? '<p class="ncp3-rv-body">' + ncp3Esc(rv.body) + '</p>' : '')
            + '</div>';
          if (!media) el.classList.add('is-plain');
          grid.appendChild(el);
        });
        if ((d.pagination || {}).hasMore) {
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'ncp3-rv-more'; btn.setAttribute('data-ncp3-rv-more', '1');
          btn.textContent = 'Show more reviews';
          btn.addEventListener('click', function () { btn.disabled = true; ncp3RvLoad(root, store, pid, list, page + 1); });
          list.appendChild(btn);
        }
        box.classList.add('is-ready');
      }).catch(function () {
        if (page === 1) { list.innerHTML = '<p class="ncp3-rv-empty">Could not load reviews.</p>'; box.classList.add('is-ready'); }
      });
    }

    /* ── reviews popup: an iframe onto the bare Loox view; nothing loads until the first tap ── */
    function ncp3Reviews(root, handle, pill) {
      var box = root.querySelector('[data-ncp3-rv]'), scrim = root.querySelector('[data-ncp3-rv-scrim]'), frame = root.querySelector('[data-ncp3-rv-frame]');
      if (!box || !frame) return;
      box.classList.remove('is-ready');
      var ttl = root.querySelector('[data-ncp3-rv-title]');
      if (ttl) ttl.textContent = pill.getAttribute('data-title') || ttl.getAttribute('data-collection');
      var sub = root.querySelector('[data-ncp3-rv-sub]'), rating = pill.getAttribute('data-rating'), count = Number(pill.getAttribute('data-count') || 0);
      var star = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg>';
      sub.innerHTML = star + ' <b>' + ncp3Esc(rating) + '</b>' + (count ? ' <span class="ncp3-rv-dot">·</span> ' + count.toLocaleString('en-IN') + ' reviews' : '');
      sub.hidden = false;
      box.hidden = false; if (scrim) scrim.hidden = false; ncp3Lock(true);
      /* The storefront answers every page with frame-ancestors 'none', so an iframe pointed at the
         url is refused. Fetching the same page (same origin) and handing the HTML to srcdoc keeps
         Loox isolated in its own document while never loading a framed storefront url. */
      var list = root.querySelector('[data-ncp3-rv-list]');
      var store = root.getAttribute('data-loox-store'), pid = pill.getAttribute('data-pid');
      if (list && store && pid) {
        /* Loox groups reviews across a style, so the widget shows the family's 870. The storefront API
           answers per product with no key, which is what the count on the card is measuring. */
        frame.hidden = true; list.hidden = false; list.innerHTML = '';
        ncp3RvLoad(root, store, String(pid).replace(/\D/g, ''), list, 1);
        return;
      }
      frame.hidden = false; if (list) list.hidden = true;
      var url = '/products/' + encodeURIComponent(handle) + '?view=reviews-popup';
      frame.onload = function () { box.classList.add('is-ready'); };
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        if (box.hidden) return;
        // A handle that no longer resolves comes back as the theme's 404 page; never frame that.
        if (html.indexOf('loox-reviews-feed') === -1) { frame.srcdoc = '<p style="font:14px system-ui;padding:24px;text-align:center;color:#666">No reviews yet for this product.</p>'; box.classList.add('is-ready'); return; }
        frame.srcdoc = html.replace(/<head([^>]*)>/i, '<head$1><base href="' + location.origin + '/">');
      }).catch(function () { frame.srcdoc = '<p style="font:14px system-ui;padding:24px;text-align:center;color:#666">Could not load reviews.</p>'; box.classList.add('is-ready'); });
    }
    /* The money-back band is a full-width row, so when Liquid drops it after the 8th card it lands mid-row
     on a 4- or 5-up desktop grid and the row above it ends short — the white gap. Move it to the next row
     boundary for whatever column count is actually in force, and put it back on resize. */
  function ncp3BandRow(root) {
    var grid = root.querySelector('[data-ncp3-grid]');
    if (!grid) return;
    var band = grid.querySelector('.ncp3-gridbn');
    if (!band) return;
    var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
    if (cols < 2) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.p-card'));
    if (!cards.length) return;
    var after = Number(band.getAttribute('data-after') || 0);
    if (!after) {
      after = cards.indexOf(band.previousElementSibling) + 1 || 8;
      band.setAttribute('data-after', String(after));
    }
    var target = Math.round(after / cols) * cols;         /* nearest full row */
    if (target < cols) target = cols;
    if (target > cards.length) target = Math.floor(cards.length / cols) * cols;
    if (target < 1 || target >= cards.length) { band.hidden = cards.length <= cols; return; }
    band.hidden = false;
    var ref = cards[target - 1];
    if (ref && ref.nextElementSibling !== band) ref.insertAdjacentElement('afterend', band);
  }

  function ncp3ReviewsClose(root) {
      var box = root.querySelector('[data-ncp3-rv]'), scrim = root.querySelector('[data-ncp3-rv-scrim]'), frame = root.querySelector('[data-ncp3-rv-frame]');
      if (box) box.hidden = true; if (scrim) scrim.hidden = true; if (frame) frame.removeAttribute('srcdoc'); ncp3Lock(false);
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('[data-ncp3]').forEach(ncp3ReviewsClose); });

    /* warm the reviews request while the finger is still coming down */
    ['pointerenter', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var pill = e.target.closest && e.target.closest('[data-ncp3-reviews]');
        if (pill) ncp3RvPrefetch(ncp3Root(pill), pill);
      }, { capture: true, passive: true });
    });

    /* price pane: the two range handles and the two rupee boxes drive the same facet fields */
    function ncp3PriceSync(box) {
      var lo = box.querySelector('[data-ncp3-price-range="min"]'), hi = box.querySelector('[data-ncp3-price-range="max"]');
      var li = box.querySelector('[data-ncp3-price-input="min"]'), hii = box.querySelector('[data-ncp3-price-input="max"]');
      var track = box.querySelector('[data-ncp3-price-track]');
      var max = Number(box.getAttribute('data-max')) || 0;
      if (!lo || !hi || !li || !hii) return;
      var a = Math.min(Number(lo.value) || 0, Number(hi.value) || max);
      var b = Math.max(Number(lo.value) || 0, Number(hi.value) || max);
      lo.value = a; hi.value = b; li.value = a; hii.value = b;
      if (track && max) track.style.background =
        'linear-gradient(to right, #e3e3e3 0%, #e3e3e3 ' + (a / max * 100) + '%, #111 ' + (a / max * 100) + '%, #111 ' + (b / max * 100) + '%, #e3e3e3 ' + (b / max * 100) + '%, #e3e3e3 100%)';
    }
    document.addEventListener('input', function (e) {
      var box = e.target.closest && e.target.closest('[data-ncp3-price]');
      if (!box) return;
      var t = e.target;
      if (t.hasAttribute('data-ncp3-price-input')) {
        var which = t.getAttribute('data-ncp3-price-input');
        var r = box.querySelector('[data-ncp3-price-range="' + which + '"]');
        if (r) r.value = t.value;
      }
      ncp3PriceSync(box);
    }, true);
    document.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('[data-ncp3-fs-tab]');
      if (!tab) return;
      setTimeout(function () { document.querySelectorAll('[data-ncp3-price]').forEach(ncp3PriceSync); }, 0);
    }, true);

    /* filter sheet: facet tabs down the left, one pane at a time on the right */
    document.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('[data-ncp3-fs-tab]');
      if (!tab) return;
      var sheet = tab.closest('[data-ncp3-sheet]'); if (!sheet) return;
      var want = tab.getAttribute('data-ncp3-fs-tab');
      sheet.querySelectorAll('[data-ncp3-fs-tab]').forEach(function (b) { b.classList.toggle('on', b === tab); });
      sheet.querySelectorAll('[data-ncp3-fs-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-ncp3-fs-pane') !== want; });
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target;
      var root = ncp3Root(t);
      var pill = t.closest('[data-ncp3-reviews]');
      if (pill) { e.preventDefault(); ncp3Reviews(root, pill.getAttribute('data-ncp3-reviews'), pill); return; }
      if (t.closest('[data-ncp3-rv-close]') || t.closest('[data-ncp3-rv-scrim]')) { ncp3ReviewsClose(root); return; }
      var mlTab = t.closest('[data-ncp3-ml-tab]');
      if (mlTab) {
        var ml = mlTab.closest('[data-ncp3-ml]'), want = mlTab.getAttribute('data-ncp3-ml-tab');
        ml.querySelectorAll('[data-ncp3-ml-tab]').forEach(function (b) { var on = b === mlTab; b.classList.toggle('on', on); b.setAttribute('aria-selected', String(on)); });
        ml.querySelectorAll('[data-ncp3-ml-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-ncp3-ml-pane') !== want; var tpl = p.hidden ? null : p.querySelector('template[data-ncp3-ml-tpl]'); if (tpl) { var frag = document.importNode(tpl.content, true); frag.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.removeAttribute('loading'); }); tpl.replaceWith(frag); } });
        ncp3Frames(document); ncp3RailApply(document);
        return;
      }
      var sortBtn = t.closest('[data-ncp3-sort]');
      var menus = document.querySelectorAll('[data-ncp3-sortmenu]');
      if (sortBtn) {
        var m = sortBtn.parentElement.querySelector('[data-ncp3-sortmenu]'); var open = m.hidden; menus.forEach(function (x) { x.hidden = true; });
        if (open) { var br = sortBtn.getBoundingClientRect(); m.style.top = (br.bottom + 6) + 'px'; m.style.left = Math.max(8, Math.min(br.left, window.innerWidth - 226)) + 'px'; }
        m.hidden = !open; sortBtn.setAttribute('aria-expanded', String(open)); return;
      }
      if (!t.closest('[data-ncp3-sortmenu]')) menus.forEach(function (x) { x.hidden = true; });
      var opt = t.closest('[data-ncp3-sort-opt]');
      if (opt) { e.preventDefault(); var u = new URL(location.href); var sv = opt.getAttribute('data-ncp3-sort-opt'); if (sv) u.searchParams.set('sort_by', sv); else u.searchParams.delete('sort_by'); u.searchParams.delete('page'); ncp3Go(root, u); return; }
      var clr = t.closest('[data-ncp3-clear]');
      if (clr) { var cu = new URL(clr.getAttribute('data-url'), location.href); var sb = new URL(location.href).searchParams.get('sort_by'); if (sb) cu.searchParams.set('sort_by', sb); ncp3Sheet(root, false); ncp3Go(root, cu); return; }
      if (t.closest('[data-ncp3-filter]')) { ncp3Sheet(root, true); return; }
      if (t.closest('[data-ncp3-sheet-close]') || t.closest('[data-ncp3-scrim]')) { ncp3Sheet(root, false); return; }
      if (t.closest('[data-ncp3-discover]')) { var p = root.querySelector('[data-ncp3-disc]'); if (p) ncp3DiscOpen(p); return; }
      if (t.closest('[data-ncp3-disc-close]')) { var pc = t.closest('[data-ncp3-disc]'); pc.hidden = true; ncp3Lock(false); return; }
      var tab = t.closest('[data-ncp3-disc-tab]');
      if (tab) {
        var panel = tab.closest('[data-ncp3-disc]'), slug = tab.getAttribute('data-ncp3-disc-tab');
        panel.querySelectorAll('.ncp3-disc-tab').forEach(function (b) { b.classList.toggle('on', b === tab); });
        panel.__lock = Date.now() + 700;
        var sec = panel.querySelector('[data-ncp3-disc-sec="' + slug + '"]');
        panel.scrollTo({ top: slug === 'all' || !sec ? 0 : sec.offsetTop - panel.querySelector('.ncp3-disc-top').offsetHeight + 2, behavior: 'smooth' });
        return;
      }
      var more = t.closest('[data-ncp3-more]');
      if (!more) return;
      var sid = root && root.getAttribute('data-section-id');
      if (!root) return;
      var url = new URL(more.getAttribute('data-next'), location.href);
      url.searchParams.set('section_id', sid);
      more.disabled = true; more.textContent = 'Loading…';
      fetch(url.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-ncp3-grid]'), wrap = doc.querySelector('[data-ncp3-more-wrap]');
        var mine = root.querySelector('[data-ncp3-grid]');
        if (grid) Array.prototype.slice.call(grid.children).forEach(function (c) { mine.appendChild(c); });
        var oldWrap = root.querySelector('[data-ncp3-more-wrap]');
        if (oldWrap) { if (wrap) oldWrap.replaceWith(wrap); else oldWrap.remove(); }
        var next = new URL(url); next.searchParams.delete('section_id'); history.replaceState(null, '', next.toString());
      }).catch(function () { more.disabled = false; more.textContent = 'Load more'; });
    });
  }
